<div class="popover__wrapper" [ngClass]="theme">
  <a *ngIf="theme==='theme_v1'" href="javascript:void(0)" class="logo auto-shining logo_v1">
    <span class="popover__title">
      <img loading="lazy" data-src="/assets/images/portfolio/ketto_assured_logo.png" class="assure_image img-responsive" alt="ketto assured">
    </span>
  </a>
  <a *ngIf="theme==='theme_v2'" href="javascript:void(0)" class="logo auto-shining logo_v2">
    <span class="popover__title">
      <i class="icon-verified-tick"></i> <span>Verified</span>
    </span>
  </a>
  <a *ngIf="theme==='theme_v3'" href="javascript:void(0)" class="logo auto-shining logo_v3">
    <span class="popover__title">
      <img loading="lazy" data-src="/assets/images/ketto_promise_1.png" class="assure_image img-responsive" alt="ketto assured">
    </span>
  </a>
  <a *ngIf="theme==='theme_v4'" href="javascript:void(0)" class="logo auto-shining logo_v4">
    <span class="popover__title">
      <img loading="lazy" data-src="https://d1vdjc70h9nzd9.cloudfront.net/images/ketto_assured_icon.png" class="assure_image img-responsive" alt="">
    </span>
  </a>
  <a *ngIf="theme==='theme_v5'" href="javascript:void(0)" class="logo auto-shining logo_v4">
    <span class="popover__title">
      <img loading="lazy" data-src="../assets/images/Assured1.png" class="assure_image img-responsive" alt="">
    </span>
  </a>
  <div class="popover__content">
    <div class="popover-title">{{'Stories.donations.sealTrustAuthenticity' | translatePipe | async}}</div>
    <div class="inline">
      <i class="material-icons">check_circle</i>{{'Stories.donations.directToBeneficiary' | translatePipe | async}}
    </div>
    <div class="inline">
      <i class="material-icons">check_circle</i>{{'Stories.donations.donationProtection' | translatePipe | async}}
    </div>
    <div class="inline">
      <i class="material-icons">check_circle</i>{{'Stories.donations.donorProtection' | translatePipe | async}}
    </div>
    <div class="inline">
      <i class="material-icons">check_circle</i>{{'Stories.donations.encrypted' | translatePipe | async}}
    </div>
  </div>
</div>
